var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"addressPicker"},[_c('van-area',{attrs:{"title":"选择地址","area-list":_vm.regions},on:{"cancel":_vm.handle_close,"confirm":_vm.handle_change}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }